var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterAdd = function SvgFilterAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1 L16,1 L16,2.7109375 L10,8.7109375 L10,15 L6,15 L6,8.7109375 L0,2.7109375 L0,1 Z M15,2.2890625 L15,2 L1,2 L1,2.2890625 L7,8.2890625 L7,14 L9,14 L9,8.2890625 L15,2.2890625 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M13,12 L13,10 L14,10 L14,12 L16,12 L16,13 L14,13 L14,15 L13,15 L13,13 L11,13 L11,12 L13,12 Z"
  }))));
};
export default SvgFilterAdd;